"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesTypeGroupSchema = void 0;
exports.AttributesTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/attributes.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "AttributesTypeGroup",
    "description": "AttributesTypeGroup represents one of the following types: Accordion, Anchor, AudioLanguage, Authorship, CallToAction, ContextualTextAttribute, Date, DateTime, Year, Duration, Enumeration, ExternalReference, Fact, FeaturedPartner, InfoBlock, InfoBlockGroup, InfoSnippet, KeyValue, LegalDisclaimer, LocationAttribute, Paragraph, ParagraphContainer, PartnerHostedLiveStream, PartnerStreams, QuestionAndAnswers, Quote, ReferenceLink, RelatedContentContainer, ResultsTable, SubPage, Table, TableContainer, Text, TextualArtefactContainer, TimeTable, Timestamp, TrackRecord, WebLink",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/accordion.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/anchor.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/audio-language.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/authorship.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/date.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/date-year.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/duration.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/enumeration.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/external-reference.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/fact.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/featured-partners.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/info-block.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/info-block-group.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/info-snippet.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/key-value.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/legal-disclaimer.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/location.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/paragraph.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/paragraph-container.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/partner-hosted-live-stream.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/partner-streams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/question-and-answers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/quote.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/reference-link.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/related-content-container.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/results-table.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/sub-page.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/table.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/table-container.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/time-table.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/timestamp.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/track-record.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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